import jsonp from 'jsonp';
import store from '../store';
import router from '../router';
import { $dg_loginOut, $dg_isLogin } from '../api';

export const getUserToken = () => store.state.userToken;

export const login = () => {
  window.location.href = `http://d.drcnet.com.cn/eDRCnet.common.web/login/login.aspx?gourl=${window.location.href}`;
};

export const loginOut = async (query, name) => {
  await $dg_loginOut({ flag: 'logoutp' });
  router.replace({
    name,
    query: {
      ...query,
      token: '',
    },
  });
  store.commit('User_setUserToken', '');
  let links = `${window.location.origin}/${name}`;
  Object.keys(query)
    .forEach((item, index) => {
      if (!index && item !== 'token') {
        links += `?${item}=${query[item]}`;
      } else if (item !== 'token') {
        links += `&${item}=${query[item]}`;
      }
    });
  window.location.href = links;
  // jsonp('http://d.drcnet.com.cn/eDRCnet.common.web/login/login.ashx?flag=logoutp', null, (err, data) => {
  //   if (err) {
  //     console.error(err.message);
  //   } else {
  //     router.replace({
  //       name,
  //       query: {
  //         ...query,
  //         token: '',
  //       },
  //     });
  //     store.commit('User_setUserToken', '');
  //     let links = `${window.location.origin}/${name}`;
  //     Object.keys(query).forEach((item, index) => {
  //       if (!index && item !== 'token') {
  //         links += `?${item}=${query[item]}`;
  //       } else if (item !== 'token') {
  //         links += `&${item}=${query[item]}`;
  //       }
  //     });
  //     window.location.href = links;
  //   }
  // });
};

export const isLogin = async (query, name) => {
  // jsonp('http://d.drcnet.com.cn/eDRCnet.common.web/login.ashx', null, (err, data) => {
  //   if (err) {
  //     console.log(err.message);
  //   } else {
  //     if (data.UserToken) {
  //       store.commit('User_setUserToken', data.UserToken);
  //     } else {
  //       loginOut(query, name);
  //     }
  //   }
  // });
  // jsonp('https://user.drcnet.com.cn/userapi/loginController/initLogin', null, (err, data) => {
  //   if (err) {
  //     console.log(err.message);
  //   } else {
  //     if (data.UserToken) {
  //       store.commit('User_setUserToken', data.UserToken);
  //     } else {
  //       loginOut(query, name);
  //     }
  //   }
  // });
  const data = await $dg_isLogin();
  if (data.UserToken) {
    store.commit('User_setUserToken', data.UserToken);
  } else {
    loginOut(query, name);
  }
};
